/** 租户停用业务码(与 backend 40391 一致) */
export const TENANT_SUSPENDED_BIZ_CODE = 40391

export interface TenantSupportContact {
  phone?: string
  email?: string
  qrcode_url?: string
  message?: string
}

export interface TenantSuspendedPayload {
  tenant_status?: string
  tenant_name?: string
  support?: TenantSupportContact
}

const STORAGE_KEY = 'silkreels.tenant_suspended'

export function saveTenantSuspendedPayload(payload: TenantSuspendedPayload): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch {
    /* ignore */
  }
}

export function readTenantSuspendedPayload(): TenantSuspendedPayload | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as TenantSuspendedPayload
  } catch {
    return null
  }
}

export function clearTenantSuspendedPayload(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

export function isTenantSuspendedStatus(status?: string): boolean {
  return status === 'suspended'
}

export function extractSuspendedPayload(payload: unknown): TenantSuspendedPayload | null {
  if (!payload || typeof payload !== 'object') return null
  const root = payload as Record<string, unknown>
  const data =
    root.data && typeof root.data === 'object'
      ? (root.data as Record<string, unknown>)
      : root
  if (data.tenant_status !== 'suspended' && root.code !== TENANT_SUSPENDED_BIZ_CODE) {
    return null
  }
  return {
    tenant_status: (data.tenant_status as string) || 'suspended',
    tenant_name: data.tenant_name as string | undefined,
    support: data.support as TenantSupportContact | undefined,
  }
}
